<template>
  <div class="yxt-list__wrapper">
    <div class="checked_list_box">
      <yxt-scrollbar
        :fit-height="true"
      >
        <div class="checked_list_tag-wraper">
          <div v-if="skillData.length > 0">
            <div
              v-if="source === 1"
              class="font-medium mb12 grey-59"
            >
              {{ $t('pc_biz_gwnl_ability') }}
            </div>
            <yxt-tag
              v-for="(item, index) in skillData"
              :key="item.id"
              disable-transitions
              class="mr8 polestar_tag"
              size="small"
              type="info"
              style="margin-bottom: 8px;"
              closable
              @close="handleClose(item, index)"
            >
              <yxt-tooltip
                effect="dark"
                :open-filter="true"
                :content="item.name"
                placement="top"
              >
                <span
                  :class="['tag_span', item.includeAll === 1 ? 'tag_span_width_tail' : '' ]"
                >{{ item.name }} </span>
              </yxt-tooltip>
            </yxt-tag>
          </div>
          <div v-if="taskData.length > 0">
            <div
              v-if="source === 1"
              class="font-medium mb12 grey-59 font"
              :class="{'mt20': skillData.length > 0}"
            >
              {{ $t('pc_biz_web_resTasks') }}
            </div>
            <yxt-tag
              v-for="(item, index) in taskData"
              :key="item.id"
              disable-transitions
              class="mr8 polestar_tag"
              size="small"
              type="info"
              style="margin-bottom: 8px;"
              closable
              @close="handleClose(item, index)"
            >
              <yxt-tooltip
                effect="dark"
                :open-filter="true"
                :content="item.name"
                placement="top"
                max-width="240"
              >
                <span
                  :class="['tag_span', item.includeAll === 1 ? 'tag_span_width_tail' : '' ]"
                >{{ item.name }} </span>
              </yxt-tooltip>
            </yxt-tag>
          </div>
        </div>
      </yxt-scrollbar>
    </div>
    <span
      v-if="list.length === 0"
      class="check-list__placeholder"
    >{{ $t('pc_biz_eval_pleaseSelect') }}</span>
    <div class="operation">
      <yxt-button
        class="font-size-14 color-primary-6 hover-primary-6"
        type="text"
        :disabled="list.length === 0"
        @click="clear"
      >
        {{ $t('biz_udp_clear_all') }}
      </yxt-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    source: {
      type: Number,
      default: 1 // 1关联词条，2考核
    }
  },
  data() {
    return {
      imgs: [
        'dept',
        'position',
        'usergroup',
        'role',
        'pos-grade',
        'person-center'
      ]
    };
  },
  computed: {
    taskData() {
      return this.list.filter(item => item.type === 2);
    },
    skillData() {
      return this.list.filter(item => item.type === 1);
    }
  },
  methods: {
    handleClose(tag, index) {
      this.$emit('close', { tag, index });
    },
    clear() {
      this.$emit('clear');
    }
  }
};
</script>
<style lang="scss" scoped>
.yxt-list__wrapper {
  position: absolute;
  top: 0;
  right: -24px;
  bottom: 0;
  box-sizing: border-box;
  width: 240px;
  margin-top: -24px;
  margin-bottom: -24px;
  padding: 24px 20px 56px;
  border-left: solid 1px #e9e9e9;

  .operation {
    position: absolute;
    bottom: 24px;
    left: 24px;
    line-height: 22px;
  }

  .check-list__placeholder {
    position: absolute;
    top: 24px;
    left: 20px;
    color: #bfbfbf;
    font-size: 14px;
  }
}

.checked_list {
  position: relative;
  height: 100%;

  .operation {
    position: absolute;
    bottom: 39px;
    left: 25px;
    display: flex;
    justify-content: space-between;

    span:nth-child(2) {
      color: #436bff;
      cursor: pointer;
    }
  }

  .check-list__placeholder {
    position: absolute;
    top: 24px;
    left: 20px;
    color: #bfbfbf;
    font-size: 14px;
  }

  .checked_list_box {
    box-sizing: border-box;
    height: calc(100vh - 160px);
    padding: 8px;
    padding-top: 24px;
    padding-left: 24px;
    overflow-x: auto;
    border-radius: 4px;

    .checked_list_tag-wraper {
      max-height: 550px;
    }

    .tag {
      margin-right: 8px;
      margin-bottom: 10px;
    }

    .tag_span {
      max-width: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .tag_span_width_tail {
      max-width: 94px;
    }
  }
}
</style>
